/**
 * Thermal receipt stylesheet for till-close audit reports (80 mm).
 * Keep thermal rules in sync with {@link TICKET_CSS_STYLE} in `ticket.style.ts`
 * (same `.upp-ticket-print` contract and `htmlBuilder` wrapper).
 */
export const AUDIT_CSS_STYLE = `
body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: #000;
    font-family: 'Roboto Condensed', Helvetica, Arial, monospace, sans-serif;
}

.upp-ticket-print {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.3;
}

.upp-ticket-print,
.upp-ticket-print *,
.upp-ticket-print *::before,
.upp-ticket-print *::after {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}

.upp-ticket-print tr[style*="background"] > td {
    background-color: inherit !important;
}

.upp-ticket-print tr[style*="color"] > td {
    color: inherit !important;
}

.upp-ticket-print tr[style*="background: lightgray"] > td,
.upp-ticket-print tr[style*="background: #e8e8e8"] > td,
.upp-ticket-print tr[style*="background:#e8e8e8"] > td {
    background-color: #e8e8e8 !important;
}

.upp-ticket-print .printing {
    position: relative;
    height: fit-content;
    width: 100%;
    z-index: 1;
    opacity: 1;
    display: block;
}

.upp-ticket-print .printing--thermal {
    width: var(--upp-ticket-thermal-width, 80mm);
    max-width: 100%;
    margin: 0 auto;
}

.upp-ticket-print .print-view {
    position: relative;
    display: block;
    text-align: left;
    text-transform: none;
    background: #fff;
    color: #000;
}

.upp-ticket-print .print-view--thermal {
    margin: 0 1px;
    padding: 10px 5px;
    font-family: 'Roboto Condensed', Helvetica, monospace, sans-serif;
    font-weight: bold;
    font-size: 14px;
}

.upp-ticket-print .padding {
    padding: 0 5px;
}

.upp-ticket-print table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0 0 0;
}

.upp-ticket-print tr {
    line-height: 1.4em;
}

.upp-ticket-print td {
    height: inherit !important;
    font-size: inherit !important;
    vertical-align: top;
}

.upp-ticket-print td.center {
    text-align: center;
}

.upp-ticket-print td.left {
    text-align: left;
}

.upp-ticket-print td.right {
    padding-left: 10px;
    white-space: nowrap;
    width: 1%;
    text-align: right;
    min-width: fit-content;
}

.upp-ticket-print .section-head td {
    height: 35px;
    background-color: #e8e8e8 !important;
    padding: 0 5px;
    text-align: center;
    text-transform: uppercase;
    vertical-align: middle;
}

@media print {
    body {
        margin: 0;
    }
}
`.trim();

const AUDIT_PAGE_RULE = '@page { size: 80mm auto; margin: 0mm; }';

/**
 * Returns the CSS payload used for printable audit close documents.
 */
export const auditStyle = (): string => {
    return `${AUDIT_PAGE_RULE}\n${AUDIT_CSS_STYLE}`;
};
